module.exports = __webpack_public_path__ + "static/media/uni_logo_ucl.bb58473f.png";